import {
  GuardsCheckEnd,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';

/**
 * Logs router activity. Angular reports nothing to the console when a guard
 * blocks a route, a redirect fires, or a URL falls through to the '**'
 * wildcard, so those look like silent no-ops. This makes every navigation,
 * lazy-module load, guard verdict, cancellation and error visible.
 *
 * Registered as an APP_INITIALIZER so it is attached before the first
 * navigation.
 */
export function routerDiagnosticsInitializer(router: Router): () => void {
  return () => {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        console.info(`[router] start #${event.id} ${event.url} (${event.navigationTrigger})`);
      } else if (event instanceof RouteConfigLoadStart) {
        console.info(`[router] lazy-loading module for '${event.route.path}'`);
      } else if (event instanceof RouteConfigLoadEnd) {
        console.info(`[router] lazy module loaded for '${event.route.path}'`);
      } else if (event instanceof GuardsCheckEnd && !event.shouldActivate) {
        console.warn(`[router] guards BLOCKED #${event.id} ${event.urlAfterRedirects}`);
      } else if (event instanceof NavigationCancel) {
        console.warn(`[router] cancelled #${event.id} ${event.url}: ${event.reason || '(no reason)'}`);
      } else if (event instanceof NavigationError) {
        console.error(`[router] ERROR #${event.id} ${event.url}:`, event.error);
      } else if (event instanceof NavigationEnd) {
        const redirected = event.urlAfterRedirects !== event.url;
        console.info(
          `[router] end #${event.id} ${event.url}` +
            (redirected ? ` -> redirected to ${event.urlAfterRedirects}` : '')
        );
      }
    });
  };
}
